import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ShopFormLayer from "../components/ShopFormLayer";

const ShopFormPage = () => {
  return (
    <>
      <MasterLayout>
        <ShopFormLayer />
      </MasterLayout>
    </>
  );
};

export default ShopFormPage;
